import React, { useState, useEffect, useContext } from "react";
import DjContext from "./DJContext";
import { getUsers } from "../api";
import UserContext from "./UserContext";

export default function DjContextProvider({ children }) {
  const [pendingDjs, setPendingDjs] = useState(0);

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (userContext.user?.role === "admin") {
      (async () => {
        const data = await getUsers("dj");
        if (data.length) {
          setPendingDjs(data.filter((dj) => dj.status === "pending").length);
        }
      })();
    }
  }, [userContext.user?.role]);

  return (
    <DjContext.Provider value={{ pendingDjs, setPendingDjs }}>
      {children}
    </DjContext.Provider>
  );
}
